// extracted by mini-css-extract-plugin
module.exports = {"navigationMobileHeading":"styles_navigationMobileHeading__yUw0W","logoMenu":"styles_logoMenu__L1D3y","iconClose":"styles_iconClose__9oMI_"};